<p *ngIf="mapError" role="status" class="alert alert-info">{{mapError}}</p>
<div *ngIf="isLoading == true" class="row h-100 justify-content-center align-items-center">
  <div class="text-center">
    <br>
    <br>
    Loading map...
  </div>
</div>
<div *ngIf="isLoading == false && memberLocArr.length == 0" class="row h-100 justify-content-center align-items-center">
  <div class="text-center">
    <br>
    <br>
    No valid addresses selected!
  </div>
</div>
<div #map style="margin-top:15px; width:100%;height: calc(100vh - 130px)"></div>
